// extracted by mini-css-extract-plugin
export default {"imgOpacity":"kycImage_imgOpacity__jSrAm"};